globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { BoltIcon, ChevronRightIcon, BuildingOfficeIcon, ChevronLeftIcon, BookmarkIcon, ArrowLeftIcon, PlusSmallIcon, TrashIcon, CheckCircleIcon, ArrowDownOnSquareIcon, ArrowRightIcon, PencilSquareIcon, PencilIcon, MapIcon, BellIcon, Bars3Icon, ArrowRightOnRectangleIcon, DocumentTextIcon, RocketLaunchIcon, InformationCircleIcon, BriefcaseIcon, PlusIcon, ChevronUpIcon, ChevronDownIcon, ArrowTopRightOnSquareIcon, ClipboardIcon, PlusCircleIcon, ClipboardDocumentIcon, ChevronUpDownIcon, FaceFrownIcon, ChatBubbleLeftRightIcon, PrinterIcon, Cog6ToothIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { BookmarkIcon as BookmarkSolidIcon, XMarkIcon as XMarkSolidIcon, AdjustmentsHorizontalIcon, ChartBarIcon, EyeIcon, QrCodeIcon, PencilSquareIcon as PencilSquareSolidIcon, ArrowDownTrayIcon, ChatBubbleOvalLeftEllipsisIcon, ArrowPathIcon, EllipsisHorizontalIcon, EyeSlashIcon, ArrowUpTrayIcon } from '@heroicons/react/24/solid'; // --> types

import { ResetIcon, getAssetSrc, HeadphoneIcon, ApplyMoreFiltersIcon, BellAlertIcon, UmbrellaIcon, LockOpenIcon, ShareIcon, ReceptionIcon, SalaIcon, CucinaIcon, BarIcon, PencilModifyIcon, UploadIcon } from '@restworld/utils-common';
import { Spinner } from '../spinner';
import { jsx as _jsx } from "react/jsx-runtime";
export var buttonIconMap = {
  BoltIcon: /*#__PURE__*/_jsx(BoltIcon, {
    className: "h-4 w-4"
  }),
  ShareIcon: /*#__PURE__*/_jsx(ShareIcon, {
    size: 16
  }),
  ShareSmallIcon: /*#__PURE__*/_jsx(ShareIcon, {
    size: 20,
    stroke: "#1C1327"
  }),
  ShareWhiteIcon: /*#__PURE__*/_jsx(ShareIcon, {
    size: 24,
    stroke: "#ffffff"
  }),
  ChevronRightIcon: /*#__PURE__*/_jsx(ChevronRightIcon, {
    className: "w-5 h-5"
  }),
  ChevronLeftIcon: /*#__PURE__*/_jsx(ChevronLeftIcon, {
    className: "w-5 h-5"
  }),
  OfficeBuildingIcon: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/office-building-icon.svg'),
    className: "h-5 w-5",
    alt: ""
  }),
  BuildingOfficePurpleIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
    className: "h-5 text-primary-800"
  }),
  BuildingOfficeWhiteIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
    className: "h-5 text-white"
  }),
  BookmarkIcon: /*#__PURE__*/_jsx(BookmarkIcon, {
    className: "h-6 w-6"
  }),
  BookmarkSolidIcon: /*#__PURE__*/_jsx(BookmarkSolidIcon, {
    className: "h-6 w-6 text-primary-800"
  }),
  ArrowLeftIcon: /*#__PURE__*/_jsx(ArrowLeftIcon, {
    className: "h-6 w-6 font-medium text-black"
  }),
  ArrowRightIcon: /*#__PURE__*/_jsx(ArrowRightIcon, {
    className: "h-5 w-5 font-medium"
  }),
  ArrowRightPurpleIcon: /*#__PURE__*/_jsx(ArrowRightIcon, {
    className: "h-5 w-5 font-medium text-primary-700"
  }),
  PlusSmallIcon: /*#__PURE__*/_jsx(PlusSmallIcon, {
    className: "h-6 w-6 text-black"
  }),
  PlusPurpleSmallIcon: /*#__PURE__*/_jsx(PlusSmallIcon, {
    className: "w-5 h-5 text-primary-700"
  }),
  WhiteTrashIcon: /*#__PURE__*/_jsx(TrashIcon, {
    className: "h-5 w-5 text-white"
  }),
  RedTrashIcon: /*#__PURE__*/_jsx(TrashIcon, {
    className: "h-5 w-5 text-red-600"
  }),
  RedTrashIconSmall: /*#__PURE__*/_jsx(TrashIcon, {
    className: "h-4 w-4 text-red-600"
  }),
  GrayTrashIcon: /*#__PURE__*/_jsx(TrashIcon, {
    className: "h-5 w-5 text-gray-400 "
  }),
  PrimaryTrashIcon: /*#__PURE__*/_jsx(TrashIcon, {
    className: "h-5 w-5 text-primary-700 "
  }),
  XMarkIcon: /*#__PURE__*/_jsx(XMarkSolidIcon, {
    className: "h-5 w-5 text-primary-800"
  }),
  XMarkIconWhite: /*#__PURE__*/_jsx(XMarkSolidIcon, {
    className: "h-5 w-5 text-white"
  }),
  XMarkIconBlack: /*#__PURE__*/_jsx(XMarkSolidIcon, {
    className: "h-6 w-6 text-black"
  }),
  SuccessIcon: /*#__PURE__*/_jsx(CheckCircleIcon, {
    className: "h-5 w-5 text-green-500"
  }),
  CurleTippedPencilIcon: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/pencil-edit-skip-icon.svg'),
    className: "h-5 w-5",
    alt: ""
  }),
  EditPencilBlackIcon: /*#__PURE__*/_jsx(PencilIcon, {
    className: "h-4 w-4 text-black"
  }),
  EditPencilWhiteIcon: /*#__PURE__*/_jsx(PencilIcon, {
    className: "h-5 w-5 text-white"
  }),
  PencilModifyIcon: /*#__PURE__*/_jsx(PencilModifyIcon, {}),
  PencilSquareIcon: /*#__PURE__*/_jsx(PencilSquareIcon, {
    className: "h-6 w-6 text-primary-800"
  }),
  ArrowDownOnSquareIcon: /*#__PURE__*/_jsx(ArrowDownOnSquareIcon, {
    className: "h-5 w-5 text-gray-900"
  }),
  ResetIcon: /*#__PURE__*/_jsx(ResetIcon, {}),
  HeadphoneIcon: /*#__PURE__*/_jsx(HeadphoneIcon, {}),
  ApplyMoreFilterWhiteIcon: /*#__PURE__*/_jsx(ApplyMoreFiltersIcon, {
    stroke: "#fff"
  }),
  ApplyMoreFilterBlackIcon: /*#__PURE__*/_jsx(ApplyMoreFiltersIcon, {
    stroke: "#1C1327"
  }),
  ApplyMoreFilterGrayIcon: /*#__PURE__*/_jsx(ApplyMoreFiltersIcon, {
    stroke: "#9CA3AF"
  }),
  BellAlertIcon: /*#__PURE__*/_jsx(BellAlertIcon, {}),
  BellIconPurple: /*#__PURE__*/_jsx(BellIcon, {
    className: "h-6 w-6 text-primary-900"
  }),
  BellIconWhite: /*#__PURE__*/_jsx(BellIcon, {
    className: "h-6 w-6 text-white"
  }),
  BellIconGray: /*#__PURE__*/_jsx(BellIcon, {
    className: "h-6 w-6 text-gray"
  }),
  MapIcon: /*#__PURE__*/_jsx(MapIcon, {
    className: "h-6 w-6 text-white"
  }),
  UmbrellaIcon: /*#__PURE__*/_jsx(UmbrellaIcon, {}),
  LockOpenIcon: /*#__PURE__*/_jsx(LockOpenIcon, {}),
  LockClosedIcon: /*#__PURE__*/_jsx(LockClosedIcon, {}),
  BarsIconBlack: /*#__PURE__*/_jsx(Bars3Icon, {
    className: "h-6 w-6 text-black"
  }),
  BarsIconWhite: /*#__PURE__*/_jsx(Bars3Icon, {
    className: "h-6 w-6 text-white"
  }),
  ArrowRightOnRectangleBlackIcon: /*#__PURE__*/_jsx(ArrowRightOnRectangleIcon, {
    className: "h-6 w-6 text-black"
  }),
  ArrowRightOnRectangleRedIcon: /*#__PURE__*/_jsx(ArrowRightOnRectangleIcon, {
    className: "h-6 w-6 text-red"
  }),
  DocumentTextIcon: /*#__PURE__*/_jsx(DocumentTextIcon, {
    className: "h-6 w-6 text-gray-900"
  }),
  RocketLaunchPurpleIcon: /*#__PURE__*/_jsx(RocketLaunchIcon, {
    className: "h-6 w-6 text-primary-900"
  }),
  ReceptionIcon: /*#__PURE__*/_jsx(ReceptionIcon, {}),
  ReceptionIconActive: /*#__PURE__*/_jsx(ReceptionIcon, {
    stroke: '#693EB5'
  }),
  SalaIcon: /*#__PURE__*/_jsx(SalaIcon, {}),
  SalaIconActive: /*#__PURE__*/_jsx(SalaIcon, {
    stroke: '#693EB5'
  }),
  CucinaIcon: /*#__PURE__*/_jsx(CucinaIcon, {}),
  CucinaIconActive: /*#__PURE__*/_jsx(CucinaIcon, {
    stroke: '#693EB5'
  }),
  BarIcon: /*#__PURE__*/_jsx(BarIcon, {}),
  BarIconActive: /*#__PURE__*/_jsx(BarIcon, {
    stroke: '#693EB5'
  }),
  InformationCircleIcon: /*#__PURE__*/_jsx(InformationCircleIcon, {
    className: "h-5 w-5 text-black"
  }),
  InformationCircleWhiteIcon: /*#__PURE__*/_jsx(InformationCircleIcon, {
    className: "h-5 w-5 min-w-[20px] text-white"
  }),
  BriefcaseIcon: /*#__PURE__*/_jsx(BriefcaseIcon, {
    className: "h-5 w-5 text-black"
  }),
  BriefcaseWhiteIcon: /*#__PURE__*/_jsx(BriefcaseIcon, {
    className: "h-5 w-5 text-white"
  }),
  RocketLaunchGrayIcon: /*#__PURE__*/_jsx(RocketLaunchIcon, {
    className: "h-6 w-6 text-gray-500"
  }),
  UploadIcon: /*#__PURE__*/_jsx(UploadIcon, {}),
  ChevronUpBlack: /*#__PURE__*/_jsx(ChevronUpIcon, {
    className: "h-5 w-5 text-black"
  }),
  ChevronDownBlack: /*#__PURE__*/_jsx(ChevronDownIcon, {
    className: "h-5 w-5 text-black"
  }),
  ArrowTopRightOnSquarePurpleIcon: /*#__PURE__*/_jsx(ArrowTopRightOnSquareIcon, {
    className: "h-5 w-5 text-primary-900"
  }),
  ArrowTopRightOnSquareBlackIcon: /*#__PURE__*/_jsx(ArrowTopRightOnSquareIcon, {
    className: "h-5 w-5 text-black"
  }),
  ClipboardIcon: /*#__PURE__*/_jsx(ClipboardIcon, {
    className: "h-5 w-5"
  }),
  LoadingIcon: /*#__PURE__*/_jsx(Spinner, {
    color: "primary",
    size: "xs"
  }),
  PlusCircleIcon: /*#__PURE__*/_jsx(PlusCircleIcon, {
    className: "h-5 w-5 text-primary-800"
  }),
  AdjustmentsHorizontalIcon: /*#__PURE__*/_jsx(AdjustmentsHorizontalIcon, {
    className: "h-5 w-5 text-black"
  }),
  ChartBarIcon: /*#__PURE__*/_jsx(ChartBarIcon, {
    className: "h-4 w-4 text-neutral-700"
  }),
  EyeIcon: /*#__PURE__*/_jsx(EyeIcon, {
    className: "h-4 w-4"
  }),
  QrCodeIcon: /*#__PURE__*/_jsx(QrCodeIcon, {
    className: "h-5 w-5"
  }),
  ClipboardDocumentIcon: /*#__PURE__*/_jsx(ClipboardDocumentIcon, {
    className: "h-5 w-5"
  }),
  PencilSquareSolidIcon: /*#__PURE__*/_jsx(PencilSquareSolidIcon, {
    className: "h-4 w-4"
  }),
  ArrowDownTrayIcon: /*#__PURE__*/_jsx(ArrowDownTrayIcon, {
    className: "h-5 w-5"
  }),
  ChevronUpDownIcon: /*#__PURE__*/_jsx(ChevronUpDownIcon, {
    className: "h-5 w-5 text-purple-500"
  }),
  ChatBubbleOvalLeftEllipsisIcon: /*#__PURE__*/_jsx(ChatBubbleOvalLeftEllipsisIcon, {
    className: "h-5 w-5 text-purple-500"
  }),
  ArrowPathIcon: /*#__PURE__*/_jsx(ArrowPathIcon, {
    className: "h-5 w-5 text-gray-500"
  }),
  EllipsisHorizontalIcon: /*#__PURE__*/_jsx(EllipsisHorizontalIcon, {
    className: "h-6 w-6"
  }),
  PlusIcon: /*#__PURE__*/_jsx(PlusIcon, {
    className: "h-4 w-4"
  }),
  ChevronDownIcon: /*#__PURE__*/_jsx(ChevronDownIcon, {
    className: "h-4 w-4"
  }),
  ChevronUpIcon: /*#__PURE__*/_jsx(ChevronUpIcon, {
    className: "h-4 w-4"
  }),
  FaceFrownIcon: /*#__PURE__*/_jsx(FaceFrownIcon, {
    className: "h-5 w-5"
  }),
  ChatBubbleLeftRightIcon: /*#__PURE__*/_jsx(ChatBubbleLeftRightIcon, {
    className: "h-5 w-5"
  }),
  EyeSlashIcon: /*#__PURE__*/_jsx(EyeSlashIcon, {
    className: "h-5 w-5"
  }),
  EyeIconAlt: /*#__PURE__*/_jsx(EyeIcon, {
    className: "h-5 w-5"
  }),
  ArrowUpTrayIcon: /*#__PURE__*/_jsx(ArrowUpTrayIcon, {
    className: "h-5 w-5"
  }),
  PrinterIcon: /*#__PURE__*/_jsx(PrinterIcon, {
    className: "h-5 w-5"
  }),
  Cog6ToothIcon: /*#__PURE__*/_jsx(Cog6ToothIcon, {
    className: "h-5 w-5"
  })
};
export var variantMap = {
  ghost: {
    "borderWidth": "1px",
    "borderColor": "transparent",
    "backgroundColor": "transparent",
    "padding": "0.5rem",
    "--tw-text-opacity": "1",
    "color": "rgb(73 41 131 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(196 177 231 / var(--tw-ring-opacity))"
    }
  },
  normal: {
    "minHeight": "3rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(221 238 52 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(221 238 52 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(73 41 131 / var(--tw-text-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(199 214 47 / var(--tw-bg-opacity))"
    }
  },
  custom: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(17 24 39 / var(--tw-text-opacity))"
  },
  primary: {
    "minHeight": "3rem",
    "whiteSpace": "nowrap",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(196 177 231 / var(--tw-ring-opacity))"
    }
  },
  borderless: {
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))"
  },
  'primary-outline': {
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(142 105 206 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(73 41 131 / var(--tw-text-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(142 105 206 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(255 255 255 / var(--tw-text-opacity))"
    },
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(196 177 231 / var(--tw-ring-opacity))"
    }
  },
  danger: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(239 176 186 / var(--tw-bg-opacity))"
    },
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(221 84 107 / var(--tw-ring-opacity))"
    }
  },
  dark: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(28 19 39 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
      "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
      "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
    }
  },
  'gray-outline': {
    "whiteSpace": "nowrap",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(209 213 219 / var(--tw-ring-opacity))"
    }
  },
  'black-outline': {
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(28 19 39 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    ":focus": {
      "--tw-ring-color": "rgb(28 19 39 / 0.25)"
    }
  },
  transparent: {
    "borderStyle": "none",
    "backgroundColor": "transparent",
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(246 245 255 / var(--tw-ring-opacity))"
    }
  },
  'secondary-outline': {
    "whiteSpace": "nowrap",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(188 207 0 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(238 250 166 / var(--tw-bg-opacity))"
    },
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(188 207 0 / var(--tw-ring-opacity))"
    }
  },
  'black-text': {
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(196 177 231 / var(--tw-ring-opacity))"
    }
  },
  'danger-ghost': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "padding": "0px",
    "textAlign": "left",
    "--tw-text-opacity": "1",
    "color": "rgb(186 0 31 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
      "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
      "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
    }
  },
  'danger-with-bg': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(186 0 31 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(221 84 107 / var(--tw-ring-opacity))"
    }
  },
  'primary-light': {
    "whiteSpace": "nowrap",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1 !important",
    "color": "rgb(105 62 181 / var(--tw-text-opacity)) !important",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(196 177 231 / var(--tw-ring-opacity))"
    }
  },
  'gray-light': {
    "whiteSpace": "nowrap",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(156 163 175 / var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(107 114 128 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(209 213 219 / var(--tw-ring-opacity))"
    }
  },
  'white-ghost': {
    "borderStyle": "none",
    "backgroundColor": "transparent",
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(255 255 255 / var(--tw-ring-opacity))"
    }
  },
  'gray-50': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(249 250 251 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-ring-opacity": "1",
      "--tw-ring-color": "rgb(209 213 219 / var(--tw-ring-opacity))"
    }
  },
  'primary-small': {
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "fontSize": "0.875rem",
    "lineHeight": "1.313rem",
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))",
    ":focus": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(105 62 181 / var(--tw-text-opacity))",
      "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
      "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
      "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
    },
    "@media (min-width: 1024px)": {
      "fontSize": "0.875rem",
      "lineHeight": "1.313rem"
    }
  }
};
export var fontColorMap = {
  primary: {
    "--tw-text-opacity": "1",
    "color": "rgb(73 41 131 / var(--tw-text-opacity))"
  },
  secondary: {
    "--tw-text-opacity": "1",
    "color": "rgb(188 207 0 / var(--tw-text-opacity))"
  },
  black: {
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))"
  },
  white: {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  gray: {
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  },
  red: {
    "--tw-text-opacity": "1",
    "color": "rgb(204 0 34 / var(--tw-text-opacity))"
  },
  'neutral-700': {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  },
  'purple-500': {
    "--tw-text-opacity": "1",
    "color": "rgb(102 51 187 / var(--tw-text-opacity))"
  }
};
export var fontWeightMap = {
  normal: {
    "fontWeight": "400"
  },
  medium: {
    "fontWeight": "500"
  },
  bold: {
    "fontWeight": "700"
  },
  semibold: {
    "fontWeight": "600"
  },
  extrabold: {
    "fontWeight": "800"
  }
};